<template>
  <el-table
    :data="tableData"
    border
    style="width: 100%"
    class="table"
  >
    <el-table-column
      prop="detailId"
      :label="$t('couponShopPoolDetail.detailId')"
      align="center"
    />
    <el-table-column
      prop="couponName"
      :label="$t('couponShopPoolDetail.couponName')"
      align="center"
    />
    <el-table-column
      prop="actualPrice"
      :label="$t('couponShopPoolDetail.faceValue')"
      align="center"
    />
    <el-table-column
      prop="sendCount"
      :label="$t('couponShopPoolDetail.giveCount')"
      align="center"
    />
    <el-table-column
      prop="validityDay"
      :label="$t('couponShopPoolDetail.validity')"
      align="center"
    />
    <el-table-column
      prop="userName"
      :label="$t('couponShopPoolDetail.memberName')"
      align="center"
    />
    <el-table-column
      prop="tel"
      :label="$t('couponShopPoolDetail.phone')"
      align="center"
    />
    <el-table-column
      prop="orderId"
      :label="$t('couponShopPoolDetail.orderNo')"
      align="center"
    />
  </el-table>
</template>

<script>
export default {
  name: 'CouponShopPoolDetailTable',
  props: {
    tableData: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.table {
  margin-bottom: 20px;
}
</style>